import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=353e3b53"
import script from "./CourseCard.vue?vue&type=script&lang=js"
export * from "./CourseCard.vue?vue&type=script&lang=js"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=353e3b53&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports